var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[(_vm.props.value)?_c('v-icon',{attrs:{"color":"#FFDF3F"}},[_vm._v("\n    star\n  ")]):_c('v-icon',[_vm._v("\n    star_border\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }